import { Button, Col, Row, Typography } from "antd";
import Layout from "antd/lib/layout/layout";
import Paragraph from "antd/lib/typography/Paragraph";
import React from "react";
import myPhoto from "../../../Assets/Images/1.png";
import {
  TwitterOutlined,
  LinkedinOutlined,
  GithubOutlined,
  WhatsAppOutlined,
  MailOutlined,
  HomeOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

const Introduction = () => {
  return (
    <Layout style={{ padding: "4rem 0" }}>
      <Row justify="center" align="middle">
        <Col xs={23} sm={23} md={12} lg={12} xl={10} xxl={10}>
          <img src={myPhoto} alt="myPhoto" height="400" />
        </Col>

        <Col xs={23} sm={23} md={12} lg={12} xl={10} xxl={10}>
          <Title level={4} style={{ textAlign: "center" }}>
            My Introduction
          </Title>
          <Paragraph style={{ textAlign: "justify" }}>
            Hello! I am Abdur Rahman. A Passionate Web Developer. I Develop
            Frontend Web Application and Backend web Application. my core skill
            is based on javascript and I love to do most of the things using
            javascript. I love to make the web more open in the world. I have to
            study completing a Diploma in Computer Engineering Technology and
            currently bachelor's degree in Computer Science Engineering from the
            Green university of Bangladesh. I am available for any kind of job
            opportunity that suits my interests.
          </Paragraph>
          <Paragraph strong>
            <MailOutlined /> : Abdur.rahman200301@gmail.com
          </Paragraph>
          <Paragraph strong>
            <WhatsAppOutlined /> : 01705952160
          </Paragraph>
          <Paragraph strong>
            <HomeOutlined /> : Dhaka Bangladesh
          </Paragraph>
          <Button.Group>
            <a
              href="https://www.linkedin.com/in/abdurrahmanakaid/"
              target="_blank"
              rel="noreferrer"
            >
              <Button type="primary" ghost>
                <LinkedinOutlined />
                Linked in
              </Button>
            </a>
            <a
              href="https://github.com/abdurrahman200"
              target="_blank"
              rel="noreferrer"
            >
              <Button type="primary" danger ghost>
                <GithubOutlined /> Github
              </Button>
            </a>
            <a
              href="https://twitter.com/abdur_akaid"
              target="_blank"
              rel="noreferrer"
            >
              <Button type="primary" ghost>
                <TwitterOutlined /> Twitter
              </Button>
            </a>
          </Button.Group>
        </Col>
      </Row>
    </Layout>
  );
};

export default Introduction;
